var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQualityManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m25.388 5-2.032 2.032H3.032v18.794h25.937V12.419L31 10.387V26.43c0 .789-.64 1.428-1.429 1.428H2.43c-.79 0-1.429-.64-1.429-1.428v-20A1.427 1.427 0 0 1 2.429 5h22.96zm3.783.314a1.07 1.07 0 1 1 1.515 1.515L16.039 21.477c-.292.292-.71.375-1.08.259a1.06 1.06 0 0 1-.435-.259l-6.4-6.4a1.07 1.07 0 1 1 1.515-1.516l5.643 5.643z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityManagement);
export default __webpack_public_path__ + "static/media/quality-management.3b1150b3d8dd5394802243193e041ada.svg";
export { ForwardRef as ReactComponent };